<template>
  <div>
    <b-server-autocomplete
      v-model="documentAgreementId"
      label="Документ"
      :url="documentAgreementListUrl()"
      :error-messages="getErrorMessages(v$.documentAgreementId)"
      hide-details
      :search-min-length="3"
      placeholder="Введіть мін. 3 символи"
      @blur="v$.documentAgreementId.$touch()"></b-server-autocomplete>
  </div>
</template>

<script lang="ts">
import { BServerAutocomplete } from 'best-modules/components'
import { ref } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { documentAgreementListUrl } from '@/requests/documentAgreement'
import { getErrorMessages } from 'best-modules/utils'

export default {
  name: 'SelectDocumentAgreement',
  components: { BServerAutocomplete },
  props: {
    dialog: {
      type: Object,
      required: true,
    },
  },
  methods: { getErrorMessages, documentAgreementListUrl },
  setup() {
    const documentAgreementId = ref()

    const v$ = useVuelidate(
      { documentAgreementId: { required } },
      { documentAgreementId }
    )

    const submit = () => {
      return Promise.resolve(documentAgreementId.value)
    }

    return { documentAgreementId, v$, submit }
  },
}
</script>

<style scoped lang="scss"></style>
